const tabs = {
    platform_settings: 'Definições da plataforma',
    actions: 'Actions',
    get_started: 'Começar',
    dashboard: 'Painel',
    applications: 'Aplicações',
    api_resources: 'Recursos API',
    sign_in_experience: 'Início de sessão e conta',
    connectors: 'Conectores',
    enterprise_sso: 'SSO empresarial',
    security: 'Segurança',
    webhooks: 'Webhooks',
    organizations: 'Organizações',
    users: 'Gestão de utilizadores',
    audit_logs: 'Registos de auditoria',
    roles: 'Funções',
    docs: 'Documentação',
    tenant_settings: 'Definições do inquilino',
    mfa: 'Autenticação multifator',
    customize_jwt: 'JWT personalizado',
    signing_keys: 'Chaves de assinatura',
    organization_template: 'Modelo de organização',
};
export default Object.freeze(tabs);
